var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.628,
    height: 54.81,
    viewBox: "0 0 47.628 54.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38723",
    "data-name": "\\uADF8\\uB8F9 38723",
    transform: "translate(1.2 1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_73",
    "data-name": "\\uD328\\uC2A4 73",
    d: "M955.249,1229.64c12.49,0,22.614-9.353,22.614-20.891H932.635C932.635,1220.287,942.76,1229.64,955.249,1229.64Z",
    transform: "translate(-932.635 -1177.23)",
    fill: "none",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_74",
    "data-name": "\\uD328\\uC2A4 74",
    d: "M955.249,1229.64c12.49,0,22.614-9.353,22.614-20.891H932.635C932.635,1220.287,942.76,1229.64,955.249,1229.64Z",
    transform: "translate(-932.635 -1177.23)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_75",
    "data-name": "\\uD328\\uC2A4 75",
    d: "M985.4,1193.461H959.855l-2.479-6.479h30.5Z",
    transform: "translate(-950.012 -1161.941)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_76",
    "data-name": "\\uD328\\uC2A4 76",
    d: "M1004.2,1146.021V1131.91a3.247,3.247,0,0,0-6.494,0v14.112Z",
    transform: "translate(-978.336 -1120.981)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_78",
    "data-name": "\\uD328\\uC2A4 78",
    d: "M1008.612,1109.932a7.1,7.1,0,0,1,7.079-7.079h1.093a7.1,7.1,0,0,1,7.079,7.079",
    transform: "translate(-985.998 -1102.853)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    strokeDasharray: "0 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_79",
    "data-name": "\\uD328\\uC2A4 79",
    d: "M972.626,1109.932a7.1,7.1,0,0,0-7.079-7.079h-1.092a7.1,7.1,0,0,0-7.079,7.079",
    transform: "translate(-950.012 -1102.853)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    strokeDasharray: "0 3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceWater);
export default __webpack_public_path__ + "static/media/icon-service-water.291d401a67b79c1777e692777c5509b8.svg";
export { ForwardRef as ReactComponent };